import { ModalType } from './modal.type';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ButtonLevel } from '../button';

@Component({
  selector: 'vm-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements /*AfterContentChecked,*/ AfterViewChecked, OnChanges {
  public scrollable: boolean;
  public modalTypes = ModalType;
  private bodyElement: any;
  @Input() includeBackground = true;
  @Input() includeOkButton = false;
  @Input() okButtonText: string;
  @Input() includeCloseButton = false;
  @Input() closeButtonText: string;
  @Input() hideHeader = false;
  @Input() showFooterBorder = false;
  @Input() modalType: ModalType;
  @Input() enableToggleBodyScroll = true;
  @Input() title: string;
  @Input() includeSecondaryCloseButton = false;
  @Output() okButtonClick: EventEmitter<any> = new EventEmitter();

  @Output() closeButtonClick: EventEmitter<any> = new EventEmitter();
  @Input() okButtonLevel = ButtonLevel.TERTIARY;
  closeButtonLevel = ButtonLevel.SECONDARY;
  @ViewChild('contentWrap', { read: ElementRef }) contentElm: ElementRef;
  @HostListener('window:resize') onResize(): void {
    this.adjustScrollBorder();
  }

  constructor(private el: ElementRef, private cdRef: ChangeDetectorRef, private renderer: Renderer2) {
    this.bodyElement = this.renderer.selectRootElement('body', true);
  }

  public ngAfterViewChecked(): void {
    this.adjustScrollBorder();
    this.cdRef.detectChanges();
    this.toggleBodyScroll(true);
  }

  private adjustScrollBorder(): void {
    const modalBody = this.el.nativeElement.querySelector('.modal__body');
    this.scrollable = modalBody.scrollHeight > modalBody.clientHeight;
  }

  public onCloseClicked(event: Event): void {
    this.closeButtonClick.emit(event);
    this.toggleBodyScroll(false);
  }

  private toggleBodyScroll(open): void {
    if (this.enableToggleBodyScroll) {
      this.bodyElement.classList.toggle('no-scroll', open);
    }
  }

  public onOkClicked(event: any): void {
    this.okButtonClick.emit(event);
    this.toggleBodyScroll(false);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.adjustScrollBorder();
  }
}
